export const DASHBOARD_ACL_OBJECTS = [
    'Dashboard',
];
